import { FootprintModel } from "./footprintModel";
import { ProductModel } from "./productModel";
import { ProductClientDetailsModel } from "./productClientDetailsModel";

export class OrderLineDisplayModel {
    public product!: ProductModel;
    public footprint!: FootprintModel[];
    public clientDetails!: ProductClientDetailsModel;
}